import { openResponseWithRetry, ProviderHttpError, readJsonBody } from './http';
import type { ResolvedDeps } from './http';

/** Model APIs use cursor pages. Do not silently show a partial catalog or loop on a bad cursor. */
export async function readModelCatalog<T>(initialUrl: string, headers: Record<string, string>, deps: ResolvedDeps, page: (payload: T) => { models: string[]; next?: [string, string] }): Promise<string[]> {
  let url = initialUrl;
  const visited = new Set<string>();
  const models = new Set<string>();
  while (visited.size < 100) {
    if (visited.has(url)) throw new ProviderHttpError('模型列表分页异常，请重试', 'parse');
    visited.add(url);
    const { response, guard } = await openResponseWithRetry({ url, init: { method: 'GET', headers }, deps });
    let result: ReturnType<typeof page>;
    try { result = page(await readJsonBody<T>(response)); }
    finally { guard.dispose(); }
    result.models.forEach(model => models.add(model));
    if (!result.next) return [...models];
    const next = new URL(initialUrl); next.searchParams.set(...result.next); url = next.toString();
  }
  throw new ProviderHttpError('模型列表页数过多，请联系提供商', 'parse');
}
